import { render, staticRenderFns } from "./detail.vue?vue&type=template&id=a54b57ee&scoped=true&"
import script from "./detail.vue?vue&type=script&lang=js&"
export * from "./detail.vue?vue&type=script&lang=js&"
import style0 from "./detail.vue?vue&type=style&index=0&id=a54b57ee&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a54b57ee",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\xampp\\htdocs\\SNS_Thai\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a54b57ee')) {
      api.createRecord('a54b57ee', component.options)
    } else {
      api.reload('a54b57ee', component.options)
    }
    module.hot.accept("./detail.vue?vue&type=template&id=a54b57ee&scoped=true&", function () {
      api.rerender('a54b57ee', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/social/detail.vue"
export default component.exports